import $ from "jquery";

$(function () {
	
	// Function to open the burger menu
	let moreBtn = $(".header .more-trigger, .header .close-more-menu, .header .btn-burger-container");

	moreBtn.on("click", function (e) {
		e.preventDefault();
		$("body, html").toggleClass("js-more-menu-open");
	});

	$(".more-nav .menu-item a").on("click", function () {
		$("body, html").toggleClass("js-more-menu-open");
	});
});
